/**
 * MagniOpenBanking wordmark — the Magni brand lockup: "magn" (Egon Sans Bold,
 * magni red) + the magnifying-glass symbol as the "i" + "openbanking" (Egon
 * italic, gray). `symbolOnly` renders just the glass mark (for the collapsed
 * sidebar). Styling lives in assets/css/index.css (.magni-wm*).
 */
export default function Wordmark({
  className = '',
  symbolOnly = false,
}: {
  className?: string;
  symbolOnly?: boolean;
}) {
  if (symbolOnly) {
    return <span className={`magni-wm ${className}`} aria-label="MagniOpenBanking"><span className="magni-wm-glass" role="img" /></span>;
  }
  return (
    <span className={`magni-wm ${className}`} aria-label="MagniOpenBanking">
      <span className="magni-wm-magn">magn</span>
      <span className="magni-wm-glass" role="img" aria-label="i" />
      <span className="magni-wm-suffix">openbanking</span>
    </span>
  );
}
